<template>
  <v-app>
    <Appbar />
    <v-main>
      <v-row>
        <v-col
          cols="12"
          class="mb-2  mt-2"
        >
          <v-layout
            d-flex
            justify-center
            align-center
            class="mx-8 pa-0"
          >
            <!--     <div
              :style="`width:5px; height:100%;background-color:${accentColor}`"
              class="mr-4"
            />
            <div style="font-weight: bold;font-size: 18px;">
              プレミアムプランへのアップグレード
            </div>-->
            <v-img
              src="../assets/title.png"
              max-width="500px"
              width="200px"
            />
          </v-layout>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          md="6"
          lg="6"
          xl="6"
        >
          <v-card
            :tile="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs"
            class="mx-auto ml-sm-4 fill-width"
            flat
          >
            <v-list>
              <v-list-item three-line>
                <v-list-item-icon>
                  <v-img
                    src="../assets/mark.png"
                  />
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title style="color: var(--v-secondary-base);font-weight: bold; font-size:18px;">
                    編集中にプレビュー等のリアルタイム表示！
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    プレビューだけでなく、プロット・テーマ・資料も確認できます。
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item three-line>
                <v-list-item-icon>
                  <v-img
                    src="../assets/mark.png"
                  />
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title style="color: var(--v-secondary-base);font-weight: bold; font-size:18px;">
                    アプリ版との同期も！
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    アプリ版との同期でお出かけ中にも執筆が捗ります！
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item three-line>
                <v-list-item-icon>
                  <v-img
                    src="../assets/mark.png"
                  />
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title style="color: var(--v-secondary-base);font-weight: bold; font-size:18px;">
                    広告が非表示になります！
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    もちろんアプリ版でも広告は非表示！
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item
                three-line
              >
                <v-list-item-icon>
                  <v-img
                    src="../assets/mark.png"
                  />
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title style="color: var(--v-secondary-base);font-weight: bold; font-size:18px;">
                    画像アップロードも可能な資料作成機能が開放されます！
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item
                three-line
              >
                <v-list-item-content>
                  <v-list-item-title class="d-flex justify-center ">
                    <span
                      style="font-weight: bold; font-size:18px;background: linear-gradient(transparent 50%, yellow 50%); "
                    >
                      ７日間無料でお試しいただけます！
                    </span>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>


              <v-list-item
                v-if="isiOS"
                three-line
              >
                <v-list-item-content>
                  <v-list-item-title class="d-flex justify-center ">
                    <span
                      style="font-weight: bold; font-size:18px;"
                    >ご利用はアプリから！</span>
                  </v-list-item-title>
                  <v-list-item-subtitle class="d-flex justify-center">
                    <a
                      href="https://apps.apple.com/jp/app/novewrite/id1524194701"
                      target="_blank"
                    >
                      <img
                        class="mr-4"
                        contain
                        height="40px"
                        src="../assets/appstore.png"
                      >
                    </a>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.neconotech.novewrite&hl=ja"
                      target="_blank"
                    >
                      <img
                        class="mr-4"
                        contain
                        height="40px"
                        src="../assets/googleplay.png"
                      ></a>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          md="6"
          lg="6"
          xl="6"
        >
          <v-card
            v-if="!isiOS"
            :tile="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs"
            class="mx-auto mr-sm-4 fill-width"
            flat
          >
            <div class="px-6 py-6">
              <div
                class="mx-auto"
              >
                <v-layout
                  :style="`height: 30px;background-color: ${backgroundColor}`"
                  align-center
                  class="ma-0 mt-4 pa-0"
                  d-flex
                  justify-start
                >
                  <div
                    :style="`width:5px; height:100%;background-color:${accentColor}`"
                    class="mr-4"
                  />
                  <div
                    class="mt-1"
                    style="font-weight: bold;font-size: 18px;"
                  >
                    料金プラン
                  </div>
                </v-layout>
                <p class="mt-4 ml-4">
                  <ListIcon
                    :style="`color: ${accentColor};width:6px;height:7px`"
                    class="mr-1 mb-1"
                  />
                  月額プラン
                </p>
                <p class="ml-8">
                  250円/月
                </p>
                <p class="mt-4 ml-4">
                  <ListIcon
                    :style="`color: ${accentColor};width:6px;height:7px`"
                    class="mr-1 mb-1"
                  />
                  年額プラン
                </p>
                <p class="ml-8">
                  2500円/年(２ヶ月分お得！)
                </p>
              </div>
              <v-layout
                :style="`height: 30px;background-color: ${backgroundColor}`"
                align-center
                class="ma-0 mt-4 pa-0"
                d-flex
                justify-start
              >
                <div
                  :style="`width:5px; height:100%;background-color:${accentColor}`"
                  class="mr-4"
                />
                <div
                  class="mt-1"
                  style="font-weight: bold;font-size: 18px;"
                >
                  お支払い方法
                </div>
              </v-layout>
              <p class="mt-4 ml-4">
                <ListIcon
                  :style="`color: ${accentColor};width:6px;height:7px`"
                  class="mr-1 mb-1"
                />
                パソコンからの場合
              </p>
              <p class="ml-8">
                クレジットカード
              </p>
              <p class="mt-4 ml-4">
                <ListIcon
                  :style="`color: ${accentColor};width:6px;height:7px`"
                  class="mr-1 mb-1"
                />
                iOS・Androidアプリからの場合
              </p>
              <p class="ml-8">
                アプリをダウンロード後、アプリ内課金
              </p>
              <a
                class="ml-8"
                href="https://apps.apple.com/jp/app/novewrite/id1524194701"
                target="_blank"
              >
                <img
                  class="mr-4"
                  contain
                  height="40px"
                  src="../assets/appstore.png"
                >
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.neconotech.novewrite&hl=ja"
                target="_blank"
              >
                <img
                  class="mr-4"
                  contain
                  height="40px"
                  src="../assets/googleplay.png"
                ></a>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import Footer from '../component/Footer.vue';
import Appbar from '../component/Appbar.vue';
import Information from "@/component/Information";
import ListIcon from "@/component/svg/ListIcon";
export default {
  name: "AboutPayments",
  components: {
    Footer,
    Appbar,
    ListIcon
  },
  data() {
    return {
      accentColor: null,
      backgroundColor: null,
      isiOS:false
    }
  },
  mounted() {
    // this.isiOS= /iP(hone|(o|a)d)/.test(navigator.userAgent)
    this.accentColor = this.$vuetify.theme.themes.light.secondary
    this.backgroundColor = this.$vuetify.theme.dark ? 'black' :
        'white'
  },
}
</script>

<style scoped>

</style>